import Swiper from 'swiper/bundle'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default class SliderNav {
  constructor(el) {
    this.el = el
    this.tabs = [...this.el.querySelectorAll('.slider-nav--tabs li')]
    this.panels = [...this.el.querySelectorAll('.slider-nav--panel')]
    this.swipers = {}
    // tant que le bloc n'est pas entré dans le viewport, l'autoplay créé à
    // l'init (cf. initSwiper) reste coupé — voir initAutoplayOnScroll
    this.hasEnteredViewport = false
    this.init()
  }

  init() {
    // seul le panel actif au chargement est visible : initialiser un swiper
    // sur un panel display:none le mesure à 0px et casse son mode loop
    this.initSwiper(this.panels.find((panel) => panel.classList.contains('is-active')))
    this.initTabs()
    this.initLinks()
    this.initAutoplayOnScroll()
  }

  initSwiper(panel) {
    if (!panel || this.swipers[panel.dataset.panel]) return

    const swiperEl = panel.querySelector('.swiper')
    if (!swiperEl) return

    const swiper = new Swiper(swiperEl, {
      slidesPerView: 1,
      spaceBetween: 16,
      loop: true,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
      navigation: {
        nextEl: panel.querySelector('.slider-nav--nav-next'),
        prevEl: panel.querySelector('.slider-nav--nav-prev'),
      },
      breakpoints: {
        992: {
          slidesPerView: 2.3,
          spaceBetween: 24,
        },
      },
    })

    // Swiper démarre l'autoplay dès l'instanciation : on le coupe si le bloc
    // n'a pas encore été scrollé dans le viewport
    if (!this.hasEnteredViewport) swiper.autoplay?.stop()

    this.swipers[panel.dataset.panel] = swiper
  }

  // Démarre l'autoplay du panel actif à l'entrée du bloc dans le viewport
  // plutôt qu'au chargement de la page (le bloc peut être loin sous le fold)
  initAutoplayOnScroll() {
    ScrollTrigger.create({
      trigger: this.el,
      start: 'top 80%',
      once: true,
      onEnter: () => {
        this.hasEnteredViewport = true

        const activePanel = this.panels.find((panel) => panel.classList.contains('is-active'))
        this.swipers[activePanel?.dataset.panel]?.autoplay?.start()
      },
    })
  }

  initTabs() {
    if (!this.tabs.length) return

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const index = tab.dataset.theme

        this.tabs.forEach(t => t.classList.remove('is-active'))
        tab.classList.add('is-active')

        this.panels.forEach((panel) => {
          const isActive = panel.dataset.panel === index
          panel.classList.toggle('is-active', isActive)

          if (isActive) this.initSwiper(panel)

          // l'autoplay continue de tourner sur un panel display:none (largeur 0)
          // et corrompt sa position interne : on le coupe hors-champ, et on
          // remet à jour (update) en revenant dessus pour resynchroniser
          const swiper = this.swipers[panel.dataset.panel]
          if (!swiper) return

          if (isActive) {
            swiper.update()
            swiper.autoplay?.start()
          } else {
            swiper.autoplay?.stop()
          }
        })
      })
    })
  }

  initLinks() {
    this.el.querySelectorAll('.slider-nav--slide.is-linked').forEach((slide) => {
      const link = slide.dataset.link
      if (!link) return

      // Swiper ignore déjà les clics survenant après un drag (preventClicks par défaut).
      slide.addEventListener('click', () => {
        window.location.href = link
      })
    })
  }
}
